<script>
import { Line } from "vue-chartjs";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  extends: Line,
  computed: {
    ...mapGetters(['repeat_chart'])
  },
  mounted() {
    this.renderLineChart()
  },
  methods: {
    renderLineChart(){
      this.renderChart(
          {
            labels: this.repeat_chart.num_repeats,
            datasets: [
              {
                label: 'repeat',
                data: this.repeat_chart.percent_repeats,
                borderColor: "#51bcda",
                pointBackgroundColor: "#51bcda",
                borderWidth: 2,
                pointBorderColor: "#51bcda",
                backgroundColor: 'rgba(0, 0, 0, 0)',
              }
            ]
          },
          {
            elements: {
              line: {
                tension: 0
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: false,
                },
              }],
              yAxes: [{
                ticks: {
                  stepSize: 25,
                  max: 100,
                  min: 0,
                  beginAtZero: false,
                  callback: function(value, index, ticks) {
                    if (value !== 0) {
                      return value + '%';
                    } else {
                      return '';
                    }
                  }
                }
              }]
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: (tooltipItem, data) => {
                  const label = data.datasets[tooltipItem.datasetIndex].label;
                  const value = tooltipItem.yLabel;
                  return `${value}` + `%`
                }
              }
            },
          }
      );
    }
  }
};
</script>
